// client/src/utils/warmApplyCache.js
const PAGE_SIZE = 15;
const ss = typeof window !== 'undefined' ? window.sessionStorage : null;

function cacheSet(k, v){ try{ ss?.setItem(k, JSON.stringify(v)); }catch{} }
function cacheGet(k){ try{ const r=ss?.getItem(k); return r?JSON.parse(r):null; }catch{ return null; } }
const keyOf = (uid, sort, page, limit) => `INF_LIST:${uid}:${sort}:${page}:${limit}`;
const readyKey = (uid, sort, page) => `INF_READY:${uid}:${sort}:${page}`;
const lastKey = (uid) => `INF_LIST_LAST:${uid}`; // ✅ 추가: 사용자별 폴백 캐시 키

// 네트워크 수신(HTTP 캐시 채움)
async function prefetchFetch(urls = [], conc = 10) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  while (i < uniq.length) {
    const chunk = uniq.slice(i, i + conc); i += conc;
    // ✅ credentials 제거 (CloudFront 이미지는 인증 불필요)
    await Promise.all(chunk.map(u => fetch(u).catch(()=>{})));
  }
}

// 이미지 디코딩(브라우저 디코더로 실제 페인트 준비)
async function decodeList(urls = [], conc = 8) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  while (i < uniq.length) {
    const chunk = uniq.slice(i, i + conc); i += conc;
    await Promise.all(chunk.map(u => new Promise((res) => {
      try {
        const img = new Image();
        img.onload = () => res();
        img.onerror = () => res();
        img.src = u;
        if (img.decode) img.decode().then(res).catch(res);
      } catch { res(); }
    })));
  }
}

// idle 프리패치(백그라운드)
function prefetchIdle(urls = [], conc = 10) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  const pump = () => {
    const chunk = uniq.slice(i, i + conc); i += conc;
    // ✅ credentials 제거
    Promise.all(chunk.map(u => fetch(u).catch(()=>{}))).finally(() => {
      if (i < uniq.length) (window.requestIdleCallback ? requestIdleCallback(pump) : setTimeout(pump, 0));
    });
  };
  pump();
}

// awaitReady: 'covers' | 'covers-decode' | 'all'
// 반환값: { items, total }
export async function warmApply({ uid, sort='deadline', page=1, limit=PAGE_SIZE, awaitReady='covers' } = {}){
  try{
    const qs = new URLSearchParams({ sort, page:String(page), limit:String(limit) }).toString();
    const res = await fetch(`/api/influencer/mybiz/projects/available?${qs}`, { credentials:'include' });
    const j = await res.json().catch(()=>({}));
    if(!res.ok || !j?.ok || !Array.isArray(j.items)) return { items: [], total: 0 };

    cacheSet(keyOf(uid,sort,page,limit), { items:j.items, total:j.total });
    cacheSet(lastKey(uid), { items:j.items, total:j.total }); // ✅ 수정: 사용자별 폴백 캐시

    const covers = [];
    const galleriesAll = [];  // ✅ 변경: 전체 갤러리를 하나로

    j.items.forEach((p) => {
      if (p?.cover) covers.push(p.cover);
      if (Array.isArray(p?.gallery)) {
        galleriesAll.push(...p.gallery);  // ✅ 변경: 모든 갤러리 수집
      }
    });

    if (awaitReady === 'covers' || awaitReady === 'covers-decode' || awaitReady === 'all') {
      await prefetchFetch(covers, 12);
      if (awaitReady === 'covers-decode' || awaitReady === 'all') {
        await decodeList(covers, 8);
      }
      if (awaitReady === 'all') {
        await prefetchFetch(galleriesAll, 10);  // ✅ 변경: 전체 갤러리 fetch
        await decodeList(galleriesAll, 8);      // ✅ 변경: 전체 갤러리 디코딩
      }
      // 커버가 디코딩까지 완료됨 → 즉시 페인트 가능
      cacheSet(readyKey(uid, sort, page), { covers: true, when: Date.now() });
    } else {
      prefetchIdle(covers, 12);
      prefetchIdle(galleriesAll, 10);  // ✅ 변경: 전체 갤러리 idle
    }

    return { items: j.items, total: j.total };
  }catch{
    return { items: [], total: 0 };
  }
}

export function readWarm(uid, sort='deadline', page=1, limit=PAGE_SIZE){
  return cacheGet(keyOf(uid,sort,page,limit)) || cacheGet(lastKey(uid)); // ✅ 수정: 사용자별 폴백 캐시
}

export function isCoversReady(uid, sort='deadline', page=1){
  const r = cacheGet(readyKey(uid, sort, page));
  return !!r?.covers;
}

// ✅ 캐시 무효화 (지원 완료 후 호출)
export function clearApplyCache(uid) {
  if (!ss) return;
  try {
    const keys = [];
    for (let i = 0; i < ss.length; i++) {
      const key = ss.key(i);
      if (key && (key.startsWith(`INF_LIST:${uid}:`) || key.startsWith(`INF_READY:${uid}:`))) {
        keys.push(key);
      }
    }
    keys.forEach(k => ss.removeItem(k));
    ss.removeItem(lastKey(uid)); // ✅ 수정: 사용자별 폴백 캐시 삭제
  } catch {}
}

// ✅ 추가: 로그아웃 시 모든 사용자 캐시 정리

export function clearAllApplyCache() {
  if (!ss) return;
  try {
    const keys = [];
    for (let i = 0; i < ss.length; i++) {
      const key = ss.key(i);
      if (key && (key.startsWith('INF_LIST:') || key.startsWith('INF_READY:') || key.startsWith('INF_LIST_LAST:'))) {
        keys.push(key);
      }
    }
    keys.forEach(k => ss.removeItem(k));
  } catch {}
}